enum ViewOption {
    Both = 0,
    Leaders = 1,
    Laggards = 2,
}

export default ViewOption;
